import { Component } from 'opus-angular-seed-core';

@Component({
    template: `
    <ul class="items05">
        <li ng-repeat="pool in vm.list.items">
            <div class="inner">
                <div class="text">
                    <h2><a ui-sref="authorized.forms.questions.pools.pool.list({poolId: pool.id})">{{ pool.name }}</a></h2>
                    <dl>
                        <dt>{{ 'questions.Questions:' | translate }}</dt>
                        <dd>{{ pool.questionCount }}</dd>
                        <dt>{{ 'questions.Created:' | translate }}</dt>
                        <dd>{{ pool.createdAt * 1000 | date : 'dd.MM.yyyy' }}</dd>
                        <dt>{{ 'questions.Author:' | translate }}</dt>
                        <dd>{{ pool.author }}</dd>
                    </dl>
                </div>
            </div>
        </li>
    </ul>
    <pagination list="vm.list"></pagination>
    `
})

export default class {
    constructor ($scope, FORMS_POOL_ENUM, ListFactory, QuestionPoolResource) {
        this.FORMS_POOL_ENUM = FORMS_POOL_ENUM;
        this.QuestionPoolResource = QuestionPoolResource;

        this.list = ListFactory.createWithPagination(QuestionPoolResource.query.bind(QuestionPoolResource));
        this.list.pagination.perPage = 25;
        this.list.fetch({ status: this.FORMS_POOL_ENUM.KEYS.ACTIVE });

        $scope.$on('questionIsAdded', () => {
            this.list.fetch({ status: this.FORMS_POOL_ENUM.KEYS.ACTIVE });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/pools/list/index.js